import { createRef, Component } from 'react'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import { deepEquals, findLeftNavTreeNodeWithKey, convertToFirstLevelLeftNav, isValidRoute } from './ui-lib/utils'
import { TreeWidget } from './ui-lib/TreeWidget'
import { RouteConsumer, RouteContext } from './RouteContext'

// hide dashboard tab from left nav
// const tabToHide = 'dashboard';

class NavRoutes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedKeys: ['dashboard'], // TODO: default nav key
      licenseInfo: null,
      featuresInfo: [],
      treeData: convertToFirstLevelLeftNav(this.props.navigation, props.configLocation, props.licenseInfo, props.featuresInfo, props.isSideNavCollapsed),
      isSideNavCollapsed: false
    }

    this.treeRef = createRef()
  }

  removeTabFromLeftNav(tabKey, leftNavList) {
    return leftNavList.filter(item => {
      return item.key !== tabKey
    })
  }

  static getDerivedStateFromProps(props, state) {
    let newState = {}
    const newTreeData = convertToFirstLevelLeftNav(props.navigation, props.configLocation, props.licenseInfo, props.featuresInfo, props.isSideNavCollapsed)
    if (
      props.isSideNavCollapsed !== state.isSideNavCollapsed ||
      props.sideMenuNavItem !== state.sideMenuNavItem || // sideMenuNavItem will update in did update
      !_.isEqual(props.navigation, state.navigation) ||
      !deepEquals(props.licenseInfo, state.licenseInfo) ||
      !deepEquals(newTreeData, state.treeData) ||
      !deepEquals(props.featuresInfo, state.featuresInfo)
    ) {
      newState = {
        licenseInfo: props.licenseInfo,
        treeData: newTreeData,
        featuresInfo: props.featuresInfo,
        isSideNavCollapsed: props.isSideNavCollapsed,
        navigation: props.navigation,
      }
    }
    return newState
  }

  componentDidUpdate() {
    const { selectedKey } = this.getKeys()
    if (!this.state.selectedKeys.includes(selectedKey)) {
      const treeNode = findLeftNavTreeNodeWithKey(this.props.navigation, selectedKey)
      const { onTreeNodeSelected } = this.props
      const { sideMenuNavItem } = this.state
      const treeNodeNeedUpdate = treeNode && sideMenuNavItem !== treeNode && (
        !sideMenuNavItem ||
        (treeNode.key && sideMenuNavItem.key !== treeNode.key) ||
        (treeNode.path !== '#' && sideMenuNavItem.path !== treeNode.path)
      )
      if (treeNodeNeedUpdate) {
        this.setState({
          sideMenuNavItem: treeNode,
          selectedKeys: [selectedKey],
        }, () => {
          onTreeNodeSelected(treeNode, false)
        })
      }
      else {
        this.setState({
          selectedKeys: [selectedKey],
        })
      }
    }
  }

  componentDidMount() {
    const { selectedKey } = this.getKeys()
    if (selectedKey) {
      const key = selectedKey
      const treeNode = findLeftNavTreeNodeWithKey(this.props.navigation, key) || {}
      if (!treeNode.path === '#') {
        this.context.updateRouteValue('locationRoute', key)
      }
      this.setState({
        selectedKeys: [selectedKey]
      })
    }
  }

  getKeyFromNavigation(list) {
    const { lastVisitedUrl } = this.context
    const pathName = window.location.pathname
    const wrapLowerCase = (str, ch) => str?.toLowerCase().padStart(1, ch).padEnd(1, ch)
    const currentLoc = wrapLowerCase(pathName === '/' ? lastVisitedUrl : pathName)
    const filteredItems = list.filter(item => !item.hidden && isValidRoute(item))
    const recursiveMatchPath = (item) => (!item.isLabel && !item.hoistChildren && (
      (item.path && item.path !== '#' && currentLoc.startsWith(wrapLowerCase(item.path))) ||
      item.children?.some(recursiveMatchPath)
    ))
    const selectedItem = filteredItems.find(recursiveMatchPath) || filteredItems.find((item) => (
      !item.isLabel && !item.hoistChildren && (
        currentLoc.includes(wrapLowerCase(item.alternateKey)) ||
        currentLoc.includes(wrapLowerCase(item.path === '#' ? item.key : item.path))
      )
    ))
    return selectedItem?.key
  }

  getKeys = () => {
    return {
      selectedKey: this.getKeyFromNavigation(this.props.navigation)
    }
  }


  onSelect = (selectedKeys, info) => {
    const { onTreeNodeSelected } = this.props
    const key = selectedKeys.length > 0 ? selectedKeys[0] : this.state.selectedKeys[0]
    const treeNode = findLeftNavTreeNodeWithKey(this.props.navigation, key)
    this.setState({
      sideMenuNavItem: treeNode,
    }, () => {
      onTreeNodeSelected(treeNode, true)
    })

    // if (!treeNode.path === '#') { // this not gonna work, just ignore
    //   history.push(treeNode.path)
    //   this.context.updateRouteValue('locationRoute', treeNode.key)
    // }
  }

  renderNavMenu = () => {
    const { selectedKeys, treeData } = this.state
    return (
      <div className='spf-flex-grow sparky-rc-tree-container'>
        <TreeWidget
          treeRef={this.treeRef}
          treeData={treeData}
          // onExpand={this.onExpand}
          selectedKeys={selectedKeys}
          onSelect={this.onSelect}
        />
      </div>
    )
  }

  render() {
    return (
      <RouteConsumer>
        {() => this.renderNavMenu()}
      </RouteConsumer>
    )
  }
}

NavRoutes.contextType = RouteContext

export default withRouter(NavRoutes)
